var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"background"},[_c('div',{staticClass:"blur"},[_c('div',{staticClass:"parent"},[_c('img',{staticClass:"logo",attrs:{"alt":"Growth Nexus logo","src":require("./assets/logo.svg")}}),_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"mailto:michael@growthnexus.io"}},[_vm._v("contact")])])])])])])
}]

export { render, staticRenderFns }